import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

export function useDeleteFile() {
  const queryClient = useQueryClient();

  const deleteFile = (fileID: string) => {
    if (!fileID) {
      Promise.reject('id can not be null');
    }

    const url = `${SPARK_RESOURCE_TYPES.FILES}/${fileID}`;

    return fetchWrapper({
      url: url,
      method: 'DELETE',
    });
  };

  return useMutation('deleteFile', deleteFile, {
    onSuccess: () => {
      queryClient.invalidateQueries(['memory']);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Deleting file: ${error.message}`);
      }
    },
  });
}
